import { MembershipService, MembershipStanding } from '../services/membership.service';

/**
 * Resolve the member's standing for guard/corridor decisions, awaiting the membership
 * context pair first. Returns 'unknown' when the load never completed (a transient
 * failure keeps `loaded` false) — callers keep their existing behavior on 'unknown'
 * rather than acting on a standing claim the data cannot back.
 */
export async function resolveStanding(membership: MembershipService): Promise<MembershipStanding | 'unknown'> {
  await membership.ensureLoaded();
  const state = membership.membershipState();
  return state.loaded ? state.standing : 'unknown';
}
